module.exports = __webpack_public_path__ + "static/media/apis.f90b8912.png";